import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
	selector: 'seira-modal-confirmacao-email',
	templateUrl: './modal-confirmacao-email.component.html',
	styleUrls: ['./modal-confirmacao-email.component.scss'],
})
export class ModalConfirmacaoEmailComponent {
	@Input() email!: string;
	public onClose = new Subject<boolean>();

	constructor(public bsModalRef: BsModalRef) {}

	confirmar() {
		this.onClose.next(true);
		this.bsModalRef.hide();
	}

	declinar() {
		this.onClose.next(false);
		this.bsModalRef.hide();
	}
}
